import cn from 'classnames';
import PropTypes from 'prop-types';

function LdsSkipToMain({
  contentId = 'main',
  children = 'Skip to main content',
  isSideNav = false,
  className,
  ...rest
}) {
  return (
    <div
      className={cn(
        'lds-skip-to-main',
        {
          sideNav: isSideNav,
        },
        className
      )}
      {...rest}
    >
      <a
        className="lds-skip-link"
        tabIndex="0"
        href={`#${contentId}`}
      >
        {children}
      </a>
      <div className="lds-skip-placeholder"></div>
    </div>
  );
}

export default LdsSkipToMain;

LdsSkipToMain.propTypes = {
  contentId: PropTypes.string,
  isSideNav: PropTypes.bool,
};
